import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs'
import { IProjectNote } from '../interfaces/IProjectNote';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class ProjectNotesStoreService {
    private _data$: BehaviorSubject<IProjectNote[]> = new BehaviorSubject([] as IProjectNote[]);
    private _totalCount$: BehaviorSubject<number> = new BehaviorSubject(0);
    data: IProjectNote[] = [];
    private selectedNoteTypeIds: number[] | null = null;

    constructor(private http: HttpClient) {
    }


    public get filteredNotes(): Observable<IProjectNote[]> {
        return this._data$.asObservable();
    }

    // reflects the unfiltered note count so the header/filter controls stay visible
    // even when the current note-type selection filters the visible list down to zero
    public get noteCount$(): Observable<number> {
        return this._totalCount$.asObservable();
    }



    public set projectId(projectId: number) {
        // it ay be necessary  to push out an empty list when the projectId
        // changes - or stale data will be displayed untiil the new set of 
        // notes is retrieved
        this._data$.next([] as IProjectNote[]);
        this._totalCount$.next(0);

        this.http.get(`/api/projectnote?projectID=${projectId}`)
            .pipe(
                tap((p: IProjectNote[]) => {
                    this.data = p;
                    this._totalCount$.next(this.data.length);
                })
            )
            .subscribe(() => this.emitFilteredData());
    }


    public set selectedNoteTypes(noteTypeIds: number[]) {
        this.selectedNoteTypeIds = noteTypeIds ?? [];
        this.emitFilteredData();
    }

    addMemberNote(note: IProjectNote) {
        this.data = [note, ...(this.data ?? [])];
        this._totalCount$.next(this.data.length);
        this.emitFilteredData();
    }

    replaceMemberNote(memberNote: IProjectNote) {
        for (let i = 0; i < this.data.length; i++) {
            const projectNote = this.data[i];
            const noteTypeID = projectNote.noteTypes[0].noteTypeID;
            if (memberNote.projectNoteID == projectNote.projectNoteID && memberNote.noteTypes[0].noteTypeID == noteTypeID) {
                this.data.splice(i, 1, memberNote);
                break;
            }
        }

        this._totalCount$.next(this.data.length);
        this.emitFilteredData();
    }

    removeMemberNote(projectNoteID: number, noteText: string) {
        for (let i = 0; i < this.data.length; i++) {
            const projectNote = this.data[i];
            if (projectNote.projectNoteID == projectNoteID && projectNote.note == noteText) {
                this.data.splice(i, 1);
                break;
            }
        }

        this._totalCount$.next(this.data.length);
        this.emitFilteredData();
    }


    private emitFilteredData() {
        if (this.selectedNoteTypeIds == null) {
            this._data$.next([...(this.data ?? [])]);
            return;
        }

        if (!this.selectedNoteTypeIds.length) {
            this._data$.next([]);
            return;
        }

        const filteredData = (this.data ?? [])
            .filter(n => this.isVisible(n, this.selectedNoteTypeIds!));

        this._data$.next(filteredData);
    }

    private isVisible(note: IProjectNote, selectedNoteTypeIds: number[]): boolean {
        const visible = note.noteTypes
            .map(n => n.noteTypeID)
            .filter(x => selectedNoteTypeIds.includes(x)).length > 0;

        return visible;
    }

}
